import { FunctionComponent } from 'preact';
import { useSelector } from 'react-redux';
import { getCountdownLoaderStyleObject } from './countdownLoader.style';
import { useStyles } from '../../../../common/hooks/useStyles';
import { getCountdownLoaderId } from '../../htmlElements/htmlElementsIdGetter';
import { playerDataSelector } from '../../../../common/store/selectors/playerData.selector';
import { discoverySelector } from '../../../../common/store/selectors/discovery.selector';
import { css } from '../../../../common/styles/styles.utils';

interface CountdownLoaderComponentVariablesProps {
  onClickNextVideo: () => void;
  countdownTime: number;
  smallNextVideo?: boolean;
}

export const CountdownLoader: FunctionComponent<CountdownLoaderComponentVariablesProps> = props => {
  const {
    countdownTime,
    onClickNextVideo,
    smallNextVideo = false,
  } = props;

  const playerUniqueId = useSelector(playerDataSelector.playerInstanceUniqId);
  const nextVideo = useSelector(discoverySelector.nextVideo);
  const playerSize = useSelector(playerDataSelector.playerSize);

  const isCountDownTimeLonger = nextVideo === 'skippableContent' && playerSize !== 'small';

  const styles = useStyles(getCountdownLoaderStyleObject, [countdownTime, isCountDownTimeLonger, smallNextVideo]);
  const { countdownLoaderContainerStyle, loaderStyle, countdownLoaderStyle } = styles;

  return (
    <div id={getCountdownLoaderId(playerUniqueId)} style={css(countdownLoaderContainerStyle)} onClick={onClickNextVideo}>
      <div style={css(loaderStyle)}>
        <div style={css(countdownLoaderStyle)} />
      </div>
    </div>
  );
};
